function stubArray() {
    return [];
}

export { stubArray };
